import { Layout, Text } from '@oneaudi/unified-web-components';
import React from 'react';
import { ConsumptionsAndEmissions } from '@oneaudi/feature-app-utils';
import { Disclaimers } from './Disclaimers';
import type { AccordionSectionContent } from '../../../types';
import { Context } from '../../Context';

export interface LegalDataProps {
  consumptionsAndEmissions: AccordionSectionContent['consumptionAndEmissions'];
  disclaimers: AccordionSectionContent['disclaimers'];
  ctas: boolean;
}

export const LegalData: React.FC<LegalDataProps> = React.memo(
  ({ consumptionsAndEmissions, disclaimers, ctas }: LegalDataProps) => {
    const { localeService, oneGraphService, loggerService } = React.useContext(Context);
    if (!consumptionsAndEmissions.length && !disclaimers.length) return null;
    return (
      <Layout
        margin={
          ctas ? ['var(--spacing-relative-lg)', 0, 0, 0] : ['var(--spacing-relative-xl)', 0, 0, 0]
        }
        direction="column"
        columnGap="xs"
        data-testid="legalData"
      >
        {consumptionsAndEmissions?.length > 0 && (
          <Text
            variant={{
              type: 'copy',
              order: process.env.IS_LEGACY ? '2' : '3',
              style: 'normal',
            }}
            margin={[0, 0, 0, 0]}
          >
            <ConsumptionsAndEmissions
              ids={consumptionsAndEmissions}
              localeService={localeService}
              oneGraphService={oneGraphService}
              logger={loggerService}
            />
          </Text>
        )}
        {disclaimers?.length > 0 && <Disclaimers disclaimers={disclaimers} />}
      </Layout>
    );
  },
);

export default LegalData;
